import PropTypes from "prop-types";

export const mainProps = {
  user: PropTypes.string,
};
